var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect } from 'react';
import styled from 'styled-components';
import { LogRocketContext } from '../LogRocket/LogRocketProvider';
var StyledDiv = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: .5rem;\n  & a {\n    color: white;\n  }\n"], ["\n  margin-top: .5rem;\n  & a {\n    color: white;\n  }\n"])));
var CookieConsent = function () {
  var handleCookieChange = useContext(LogRocketContext).handleCookieChange;
  useEffect(function () {
    var targetNode = document.getElementById('teconsent');
    if (targetNode) {
      var observer_1 = new MutationObserver(function () {
        handleCookieChange();
      });
      observer_1.observe(targetNode, {
        attributes: true
      });
      return function () {
        observer_1.disconnect(); // Cleanup on unmount
      };
    }
  }, []);
  return _jsx(StyledDiv, __assign({
    id: "teconsent",
    "aria-label": "Open Cookie Preferences Modal",
    "aria-live": 'polite',
    role: "complementary"
  }, {
    children: _jsx("script", {
      src: "https://consent.trustarc.com/asset/notice.js/v/v1.7-289",
      async: true,
      crossOrigin: ""
    })
  }));
};
export default CookieConsent;
var templateObject_1;